import { render, staticRenderFns } from "./AutoPac.vue?vue&type=template&id=b9907ad8&"
import script from "./AutoPac.vue?vue&type=script&lang=js&"
export * from "./AutoPac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports